import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AuthGuard from './../components/common/AuthGuard';
import AccountPersonal from './../pages/AccountPersonal';
import Dashboard from './../pages/Dashboard';
import DocumentPage from './../pages/DocumentPage';
import ForgotPasswordPage from './../pages/ForgotPasswordPage';
import HomePage from './../pages/HomePage';
import Login from './../pages/Login';
import Post from './../pages/Post';
import PostDetail from './../pages/PostDetail';
import PrivacyPolicy from './../pages/PrivacyPolicy';
import RegistrationPage from './../pages/RegistrationPage';
import ReviewChannel from './../pages/ReviewChannel';
import Studio from './../pages/Studio';
import TermsOfService from './../pages/TermsOfService';
import TopicPage from './../pages/TopicPage';
import DonatePage from './../pages/DonatePage';
import Home from "../pages/Home";
import SearchYoutubeChannel from "../pages/SearchYoutubeChannel";

const AppRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" exact element={<HomePage />} />
                <Route path="/app/studio" element={<AuthGuard><Home /></AuthGuard>} />
                <Route path="/app/studio/:id" element={<AuthGuard><Studio /></AuthGuard>} />
                <Route path="/login" exact element={<Login />} />
                <Route path="/registration" exact element={<RegistrationPage />} />
                <Route path="/forgot-password" exact element={<ForgotPasswordPage />} />
                <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" exact element={<TermsOfService />} />
                <Route path="/app" exact element={<AuthGuard>
                    <Dashboard />
                </AuthGuard>} />
                <Route path="/app/topics" exact element={<AuthGuard><TopicPage /></AuthGuard>} />
                {/* <Route path="/app/topics/:topicId/posts" exact element={<AuthGuard><Post /></AuthGuard>} /> */}
                <Route path="/app/topics/:topicId/posts/:postId" exact element={<AuthGuard><PostDetail /></AuthGuard>} />
                <Route path="/app/AccountPersonal" exact element={<AuthGuard><AccountPersonal /></AuthGuard>} />
                <Route path="/app/documents" exact element={<AuthGuard><DocumentPage /></AuthGuard>} />
                <Route path="/app/review-channel" exact element={<AuthGuard><ReviewChannel /></AuthGuard>} />
                <Route path="/app/donate" exact element={<AuthGuard><DonatePage /></AuthGuard>} />
                <Route path="/channel" exact element={<SearchYoutubeChannel />} />
            </Routes>
        </Router>
    );
};

export default AppRoutes;
